var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopbarItem search-box"},[_c('router-link',{staticClass:"TopbarItem-link waves-effect waves-dark",class:[{ "router-link-active": _vm.jaActiveLink(_vm.$route.meta.parent) }],attrs:{"to":_vm.to}},[_c('i',{class:_vm.classIcon}),_c('span',{staticClass:"TopbarItem-link-name"},[_vm._v(_vm._s(_vm.$t(_vm.name)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }